import styled from 'styled-components';

const Scroller = styled.div`
  padding-bottom: 4rem;
`;

export default Scroller;
